/* ============================================================
   OBEE EXTRACTS · Shop
   Filter in der Übersicht, Mengenwähler, In-den-Warenkorb ohne
   Seitenwechsel. Alles funktioniert auch ohne JavaScript: die
   Formulare schicken dann ganz normal an Shopify.
   ============================================================ */
(function () {
  'use strict';
  document.documentElement.classList.add('js');
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- Filter ---------- */
  var shop = document.getElementById('shop');
  if (shop) {
    var cards = shop.querySelectorAll('.card');
    var btns = shop.querySelectorAll('.filters button');
    var countEl = shop.querySelector('.range-count');
    var active = 'all';
    var apply = function () {
      var n = 0;
      Array.prototype.forEach.call(cards, function (c) {
        var ok = active === 'all' || c.dataset.type === active ||
                 (c.dataset.family || '').split(' ').indexOf(active) > -1;
        c.classList.toggle('hidden', !ok);
        if (ok) n++;
      });
      if (countEl) countEl.textContent = 'Showing ' + n + ' of ' + cards.length;
      Array.prototype.forEach.call(btns, function (b) {
        b.setAttribute('aria-pressed', b.dataset.f === active ? 'true' : 'false');
      });
    };
    Array.prototype.forEach.call(btns, function (b) {
      b.addEventListener('click', function () { active = b.dataset.f; apply(); });
    });
    apply();
  }

  /* ---------- Mengenwähler ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-step]');
    if (!b) return;
    var inp = b.parentNode.querySelector('input');
    var min = parseInt(inp.min || '0', 10);
    var v = Math.max(min, (parseInt(inp.value, 10) || 0) + parseInt(b.dataset.step, 10));
    if (String(v) === inp.value) return;
    inp.value = v;
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Warenkorb: Menge ändern schickt das Formular sofort ab */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-autosubmit]')) e.target.form.submit();
  });

  /* ---------- In den Warenkorb ---------- */
  var setCount = function (n) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), function (el) {
      el.textContent = n; el.setAttribute('data-n', n);
    });
  };

  Array.prototype.forEach.call(document.querySelectorAll('form[data-add]'), function (form) {
    var btn = form.querySelector('[type="submit"]');
    var msg = form.parentNode.querySelector('.add-msg');
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      btn.disabled = true;
      if (msg) { msg.classList.remove('err'); msg.textContent = 'Adding…'; }
      fetch(ROOT + 'cart/add.js', {
        method: 'POST', body: new FormData(form),
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add');
          return fetch(ROOT + 'cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          setCount(cart.item_count);
          if (msg) msg.innerHTML = 'Added to cart · <a href="' + ROOT + 'cart">View cart</a>';
        })
        .catch(function (err) {
          if (msg) { msg.classList.add('err'); msg.textContent = err.message; }
        })
        .then(function () { btn.disabled = false; });
    });
  });

  /* ---------- Galerie und Sortenwahl (Handelseinheiten) ----------
     Bilder tragen data-v = Varianten-ID oder leer (gilt für alle).
     Wechsel der Sorte zeigt nur deren Bilder und ihren Preis. */
  var gal = document.querySelector('[data-gal]');
  var mainImg = gal && gal.querySelector('[data-main]');
  var thumbs = gal ? gal.querySelectorAll('.pdp-thumbs .th') : [];
  var showThumb = function (t) {
    if (!mainImg || !t) return;
    mainImg.src = t.dataset.full;
    mainImg.alt = t.getAttribute('aria-label') || '';
    Array.prototype.forEach.call(thumbs, function (x) { x.classList.toggle('on', x === t); });
  };
  Array.prototype.forEach.call(thumbs, function (t) {
    t.addEventListener('click', function () { showThumb(t); });
  });
  document.addEventListener('change', function (e) {
    var r = e.target;
    if (!r.matches('.pdp-opts input[type="radio"]')) return;
    var pb = document.querySelector('[data-price]'), pu = document.querySelector('[data-unit]');
    if (pb && r.dataset.price) pb.textContent = r.dataset.price;
    if (pu && r.dataset.unit) pu.textContent = r.dataset.unit;
    var first = null;
    Array.prototype.forEach.call(thumbs, function (t) {
      var ok = !t.dataset.v || t.dataset.v === r.value;
      t.hidden = !ok;
      if (ok && !first && t.dataset.v) first = t;
    });
    showThumb(first || Array.prototype.filter.call(thumbs, function (t) { return !t.hidden; })[0]);
    if (window.history && history.replaceState) {
      var u = new URL(location.href); u.searchParams.set('variant', r.value);
      history.replaceState(null, '', u.toString());
    }
  });

  /* ---------- Händler-Bestellseite ----------
     Zählt Devices und Summe mit, schaltet Licht und Display ab der
     Mindestmenge frei und legt alles in einem Schritt in den Warenkorb. */
  var trade = document.querySelector('[data-trade]');
  if (trade) {
    var qtys = trade.querySelectorAll('.qty input[data-id]');
    var extras = trade.querySelectorAll('[data-extra]');
    var addBtn = trade.querySelector('[data-trade-add]');
    var tMsg = trade.querySelector('.b2b-box .add-msg');
    var euro = function (cents) {
      var s = (cents / 100).toFixed(2).split('.');
      return '€' + s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + s[1];
    };
    var calc = function () {
      var dev = 0, tot = 0, lines = 0;
      Array.prototype.forEach.call(qtys, function (inp) {
        var n = Math.max(0, parseInt(inp.value, 10) || 0);
        var c = parseInt(inp.dataset.cents, 10) * n;
        dev += n * parseInt(inp.dataset.units, 10); tot += c; if (n) lines++;
        var row = inp.closest('.b2b-row');
        row.classList.toggle('has', n > 0);
        row.querySelector('[data-sum]').textContent = n ? euro(c) : '–';
      });
      Array.prototype.forEach.call(extras, function (x) {
        var cb = x.querySelector('input'), ok = dev >= parseInt(x.dataset.from, 10);
        cb.disabled = !ok; if (!ok) cb.checked = false;
        x.classList.toggle('open', ok);
        var lk = x.querySelector('[data-lock]');
        if (lk) lk.textContent = ok ? (cb.checked ? 'Added' : 'Tick to add') :
          (parseInt(x.dataset.from, 10) - dev) + ' more devices';
      });
      trade.querySelector('[data-devices]').textContent = dev;
      trade.querySelector('[data-total]').textContent = euro(tot);
      /* Margenrechner: Wiederverkaufswert pro Device kommt aus Liquid
         (UVP ohne MwSt des Landes, bei Distributoren der Händlerpreis). */
      var rb = trade.querySelector('[data-resale-cents]');
      if (rb) {
        var rv = dev * (parseInt(rb.dataset.resaleCents, 10) || 0), mg = rv - tot;
        trade.querySelector('[data-resale]').textContent = euro(rv);
        trade.querySelector('[data-margin]').textContent = euro(mg);
        trade.querySelector('[data-margin-pct]').textContent = rv ? '· ' + Math.round(mg / rv * 100) + ' %' : '';
        rb.classList.toggle('has', dev > 0);
      }
      addBtn.disabled = !lines;
    };
    trade.addEventListener('input', calc);
    trade.addEventListener('change', calc);
    calc();

    trade.addEventListener('submit', function (e) {
      e.preventDefault();
      var items = [];
      Array.prototype.forEach.call(qtys, function (inp) {
        var n = parseInt(inp.value, 10) || 0;
        if (n > 0) items.push({ id: parseInt(inp.dataset.id, 10), quantity: n });
      });
      Array.prototype.forEach.call(extras, function (x) {
        var cb = x.querySelector('input');
        if (cb.checked && !cb.disabled) items.push({ id: parseInt(cb.dataset.id, 10), quantity: 1 });
      });
      if (!items.length) return;
      addBtn.disabled = true;
      if (tMsg) { tMsg.classList.remove('err'); tMsg.textContent = 'Adding…'; }
      fetch(ROOT + 'cart/add.js', {
        method: 'POST', body: JSON.stringify({ items: items }),
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add');
          location.href = ROOT + 'cart';
        })
        .catch(function (err) {
          if (tMsg) { tMsg.classList.add('err'); tMsg.textContent = err.message; }
          addBtn.disabled = false;
        });
    });
  }
})();
